import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class QualityIncidentService {
    static getQualityIncidents(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`quality-incidents?filter=${qs}`, pageNumber));
    }
    static fetchQualityIncident(oid) {
        return lastValueFrom(BaseService.get(`quality-incidents/${oid}`));
    }
    static saveQualityIncident(dto) {
        return lastValueFrom(BaseService.save(`quality-incidents`, dto));
    }
    static deleteQualityIncident(oid) {
        return lastValueFrom(BaseService.delete(`quality-incidents/${oid}`));
    }
}
